import axios from "@/libs/http";


/**
 * 查询最新协议
 */
export const getLastClerkAgreement = ()=>{
    return axios.request({
        url: '/s/c/agreement/163/getLast',
        method: 'get'
    })
}

export const confirmClerkAgreement = (agreementId,agreementChangeLogId,signUrl)=>{
    let data = new URLSearchParams()
    data.append('agreementId',agreementId)
    data.append('agreementChangeLogId',agreementChangeLogId)
    data.append('signUrl',signUrl)
    return axios.request({
        url: '/s/c/agreement/163/confirm',
        data,
        method: 'POST'
    })
}
